export default __webpack_public_path__ + "static/media/placeholder_female.cfcd3961.jpg";